import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CnafPopupModalComponent } from '@cnaf/cnaf-commons-mon-compte-appli';
import { CnafAtTagService, CnafStatsSidModel, CnafStatsSidService, CnafTokenService, CnafUserService } from '@cnaf/ng-cnaf-commons';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { context } from '../../contexts/context';
import { LIBELLE_FORMULAIRE, LIBELLE_STAT } from '../constants/configlibelles';
import { InfosCommune } from '../models/infoscommune.model';
import { Localites } from '../models/localites.model';
import { Question } from '../models/questions.model';
import { DelaiAttente, InformationsSvi, ParametreAppel } from '../models/svi.model';
import { TagXitiService } from '../services/tagxiti.service';

declare let cordova: any;
@Injectable({
  providedIn: 'root'
})

export class CnafContacterMaCafService {
  urlLocalites: string;
  urlInfosCommune: string;
  pagesFaqResource: string;
  pagesLocalesResource: string;
  contacterCafResource: string;
  baseDeConnaissanceResource: string;
  baseDeConnaissanceArticleResource: string;
  accesPriseRdv: string;
  question: string;
  nomCaf: string;
  private _logged: boolean | undefined;
  tabCounterArticleReponses = 1;
  reponsesGeneres = false;
  processTypeActionSpecifiqueFromUrlParams = true;
  sviParametre!: ParametreAppel;
  cookieAppVersion!: string;
  androidDevice = false;
  sviDispoVersion = false;
  tagXitiService!: TagXitiService;
  delaiAttenteChargee = new BehaviorSubject({
    chargementTermine: false
  })
  constructor(
    private readonly cnafUserService: CnafUserService,
    private readonly cnafTokenService: CnafTokenService,
    private readonly modalService: BsModalService,
    protected readonly router: Router,
    private readonly cnafAtTagService: CnafAtTagService,
    private readonly http: HttpClient,
    private readonly cnafStatsSidService: CnafStatsSidService) {
    this.nomCaf = '';
    this.urlLocalites = '/api/amabisfront/v1/localites';
    this.urlInfosCommune = '/api/cnafcompteleprocfront/v1/infoscommune';
    this.pagesLocalesResource = `/api/editorialmiddle/v2/mon_compte/pages_locales`;
    this.pagesFaqResource = `/api/editorialmiddle/v1/mon_compte/faq`;
    this.contacterCafResource = `/api/contactercaffront/v1/mon_compte/contacter_caf/`;
    this.baseDeConnaissanceResource = '/api/basedeconnaissancefront/v1/mon_compte/base_de_connaissance/';
    this.baseDeConnaissanceArticleResource = '/api/basedeconnaissancefront/v1/mon_compte/base_de_connaissance/article';
    this.accesPriseRdv = '/api/accesservicemiddle/v1/acces';
    this.question = '/toDetermine';
    this._logged = undefined;
    this.cookieAppVersion = this.getCookieByName('appVersion');
    this.androidDevice = this.getCookieByName('appOs') === "android";
    this.cookieAppVersion = this.cookieAppVersion.replace(/\./g, '-');
    // Pour pouvoir comparer les versions, on transforme celle-ci en nombre (exemple 2.2.0 devient 220)
    // si la version est supérieure ou égale à 2.6.1 (261), alors le svi peut etre disponible
    this.sviDispoVersion = (parseInt(this.cookieAppVersion.split('-').join(''), 10) >= 261);

  }

  get logged(): boolean {
    if (this._logged === undefined) {
      const token = this.cnafTokenService.tokenJWT;
      if (token) {
        const decodedToken = this.cnafTokenService.decodeToken(token);
        if (decodedToken) {
          this._logged = (decodedToken.scope !== 'public');
        }
        else {
          this._logged = false;
        }
      }
      else {
        this._logged = false;
      }
    }
    return this._logged;
  }
  set logged(logged: boolean) { this._logged = logged; }

  // Mise en cache du nom de la CAF pour eviter des appels multiples
  getNomCaf(): string {
    return this.nomCaf;
  }

  setNomCaf(nom: string): void {
    this.nomCaf = nom;
  }

  getPagesLocales(): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get<any>(this.pagesLocalesResource,
      options);
  }

  getLocalites(codePostalVille: string, codePays: string): Observable<Localites> {
    const options = {
      params: new HttpParams()
        .set('codePostalVille', codePostalVille)
        .set('codePays', codePays)
    };
    return this.http.get<Localites>(this.urlLocalites, options);
  }

  getInfosCommune(codePostal: string, nidCom: string): Observable<InfosCommune> {
    const options = {
      params: new HttpParams()
        .set('code_postal', codePostal)
        .set('nidcom', nidCom)
    };
    return this.http.get<InfosCommune>(this.urlInfosCommune, options);
  }

  getPagesLocalesNonAuth(params: any): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get<any>(`${this.pagesLocalesResource}/${params.codeOrga}`,
      options);
  }

  getCourrielAutorise(): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get(`${this.contacterCafResource}autorisation_courriel`,
      options
    );
  }

  getSviInformations(): Observable<InformationsSvi> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get<InformationsSvi>(`${this.contacterCafResource}svi_visuel/informations_svi`, options);
  }

  getSviParametreAppel(): Observable<ParametreAppel> {
    if(this.sviParametre) {
      return of(this.sviParametre)
    }
    return this.http.get<ParametreAppel>(`${this.contacterCafResource}svi_visuel/parametres_appel`).pipe(
      tap((params) => {
       this.sviParametre = {
        disponibiliteFileSviVisuel : params.disponibiliteFileSviVisuel,
        numeroAComposer : params.numeroAComposer,
       }
      }));
  }
  appeldelaiAttente(motif: boolean,chapitre3: string|undefined): void{
    this.delaiAttente().subscribe(
      {
        next: (delaiAttente: DelaiAttente) => {
          this.delaiAttenteOk(delaiAttente,motif,chapitre3);
        },
        error: () => {
          this.delaiAttenteKo(motif);
        },
      });
  }
  delaiAttenteOk(delai: DelaiAttente,motif: boolean,chapitre3:string|undefined): void {
    let message = '';
    let delaiSecondes : number = parseFloat(delai.delaiAttente);
    const motifStr = motif ? 'svi_visuel_avec_motif':'svi_visuel_sans_motif';
    const sourceStr =  motif ? 'avecmotifsdecontact':'sansmotifsdecontact';
    if(!delai.disponibiliteFileSviVisuel){
      this.router.navigate(["/contactcafechecsvi"], { queryParams: { message: "fermé" } });
      return;
    }
    if(isNaN(delaiSecondes)){
      this.delaiAttenteKo(motif);
      return;
    }
    else if(delaiSecondes >= 1140000){
      this.getTagBoutonAppelerDuParcoursMotifs (motif, chapitre3);
      this.getTagDelaiDAttente('pfs_forte_affluence', context.type, 'contactermacaf', motifStr, "appeler");
      this.router.navigate(["/forteaffluence"]);
      return;
    }
    else if(delaiSecondes >= 600000 && delaiSecondes < 1140000){
      this.getTagBoutonAppelerDuParcoursMotifs (motif, chapitre3);
      this.getTagDelaiDAttente('popup_pfs_entre_10_et_20mn', context.type, 'contactermacaf', motifStr, 'appeler');
      message = 'compris entre 10 et 20 minutes';
    }
    else if(delaiSecondes >= 300000 && delaiSecondes < 600000){
      this.getTagBoutonAppelerDuParcoursMotifs (motif, chapitre3);
      this.getTagDelaiDAttente('popup_pfs_entre_5_et_10mn', context.type, 'contactermacaf', motifStr, 'appeler');
      message  = 'compris entre 5 et 10 minutes';
    }
    else {
      this.getTagBoutonAppelerDuParcoursMotifs (motif, chapitre3);
      this.getTagDelaiDAttente('popup_pfs_moins_5_mn', context.type, 'contactermacaf', motifStr, 'appeler');
      message = 'inférieur à 5 minutes';
    }
        //Le temps d’attente estimé est compris entre 10 et 20 minutes. Souhaitez-vous être mis en relation ?
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-fade modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: 'Délai d\'attente',
        content: '<p>Le temps d’attente estimé est ' + message + '</p><p>Souhaitez-vous être mis en relation ?</p>',
        textBtnLeft: 'Retour',
        textBtnRight: 'Appeler'
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    this.delaiAttenteChargee.next(
      {
        chargementTermine: true
      }
    );
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      if (reason === 'btnRight') {
        this.getSviParametreAppel().subscribe(
          {
            next: (parametreAppel: ParametreAppel) => {
              if (parametreAppel) {
                if (parametreAppel.disponibiliteFileSviVisuel) {
                  if (parametreAppel.numeroAComposer) {
                    if(!motif){
                      this.getTagBoutonAppelerPopup(message);
                    }
                    else{
                      this.getTagBoutonAppelerPopup(message);
                    }
                    //appel delai d'attente
                    if (this.androidDevice && this.sviDispoVersion) {
                      this.callAvecPlugin(parametreAppel.numeroAComposer);
                    } else {
                      window.location.href = 'tel:' + parametreAppel.numeroAComposer;
                    }
                  } else {
                    this.router.navigate(["/contactcafechecsvi"], { queryParams: { message: "indisponible", source: sourceStr } });
                  }
                } else {
                  this.router.navigate(["/contactcafechecsvi"], { queryParams: { message: "fermé" , source: sourceStr} });
                }
              }
            },
            error: () => {
              this.router.navigate(["/contactcafechecsvi"], { queryParams: { message: "indisponible", source: sourceStr } });
            },
          });
      }
      subscription.unsubscribe();
    });
  }


  delaiAttenteKo(motif: boolean): void {
    const sourceStr =  motif ? 'avecmotifsdecontact':'sansmotifsdecontact';
    this.router.navigate(["/contactcafechecsvi"], { queryParams: { message: "indisponible" , source: sourceStr } });
  }


  delaiAttente(): Observable<DelaiAttente> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get<DelaiAttente>(`${this.contacterCafResource}svi_visuel/delai_attente`,
      options
    );
  }
  getTagDelaiDAttente(name:string,context:string,chapitre1:string,chapitre2:string,chapitre3:string){
    const tagObj = this.tagXitiService.getAtTagObject(
      name,
      context,
      chapitre1,
      chapitre2,
      chapitre3
    );
    tagObj.customPropsPersistent = {
      'svi_profil': this.tagXitiService.getProfilutilisateur()
    };
    this.cnafAtTagService.pageSend(tagObj);
  }

  getTagBoutonAppelerDuParcoursMotifs (motif: boolean , chapitre3: string | undefined){
    if(!motif) return;
    const tagObj = this.tagXitiService.getAtTagObject('btn_appeler', context.type, 'contactermacaf', 'svi_visuel_choix_motif', chapitre3);
    tagObj.customPropsPersistent = {
    'svi_profil': this.tagXitiService.getProfilutilisateur()
  };
  this.cnafAtTagService.pageSend(tagObj);
}

getTagBoutonAppelerPopup(message: string){
  const cliqueAppeler: Record<string, string> = {
    'inférieur à 5 minutes': 'popup_attente_moins_5mn',
    'compris entre 5 et 10 minutes': 'popup_attente_entre_5_et_10mn',
    'compris entre 10 et 20 minutes': 'popup_attente_entre_10_et_20mn'
  }
  const cliqueName = cliqueAppeler[message] || '';
  const clickAppeler = this.tagXitiService.getAtClickObject(
    cliqueName,
    'action',
    'contactermacaf',
    'svi_visuel',
    'appeler'
  );
  this.cnafAtTagService.click(clickAppeler);
}

  callAvecPlugin(numeroAComposer: string): void {
    cordova.plugins.phonedialer.call(
      numeroAComposer,
      function () {//function call ok
      },
      function () {//function call ko
        window.location.href = 'tel:' + numeroAComposer;
      },
      false,
      true
    );
  }
  getCourrielAutoriseNonAuth(params: any): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get(`${this.contacterCafResource}autorisation_courriel/${params.codeOrga}`,
      options
    );
  }

  getCodeOrganismePersonne(): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get(`${this.contacterCafResource}code_organisme_personne`,
      options
    );
  }

  getSessionCaf(): string {
    const cookieName = 'session_caf';
    let codeOrga = document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1');
    // Cas d'un cookie ayant encore la valeur 641 / 642
    if (codeOrga === '641' || codeOrga === '642') {
      codeOrga = '643';
    }
    return codeOrga;
  }

  getCodeOrgaCreationCompteInToken(): any {
    const token = this.cnafTokenService.tokenJWT;
    if (token) {
      const decodedToken = this.cnafTokenService.decodeToken(token);
      if (decodedToken) {
        return decodedToken.codeOrgaCreationCompte;
      }
    }
    return undefined;
  }

  getCodeOrgaPivotInToken(): any {
    const token = this.cnafTokenService.tokenJWT;
    if (token) {
      const decodedToken = this.cnafTokenService.decodeToken(token);
      if (decodedToken) {
        return decodedToken.codeOrganismePivot;
      }
    }
    return undefined;
  }

  getCodeOrgaContact(profilAmi: boolean, profilUsagersPrimo: boolean): string {
    // l'AMI prime sur l'usagerprimo
    let codeOrgaContact = this.getSessionCaf();
    if (profilAmi) {
      codeOrgaContact = this.getCodeOrgaPivotInToken();
    } else if (profilUsagersPrimo) {
      codeOrgaContact = this.getCodeOrgaCreationCompteInToken();
    }
    return codeOrgaContact;
  }

  goToPage(url: string): void {
    window.location.href = url;
  }

  actionLien(typeActionSpecifique: string): boolean {
    const { profilConjointsNonRadies, profilTuteurAutresTutelles, profilTutelle4, profilEnfantsAutresPersonnes, profilUsagersPrimo, codeOrgaContact, profilAllocataires } = this.recuperationProfil();

    if (typeActionSpecifique === 'scrollToContent') {
      const ancreContenur = document.querySelector('#ancre-contenu');
      if (ancreContenur) {
        ancreContenur.scrollIntoView();
      }
      return false;
    } else if (typeActionSpecifique === 'envoyerMail') {
      if (this.logged) {
        this.redirectPageSelonProfil(profilConjointsNonRadies, profilTuteurAutresTutelles, profilTutelle4, profilEnfantsAutresPersonnes, profilUsagersPrimo);
        return false;
      }
      else {
        this.modalNonIdentifie();
        return false;
      }
    } else if (typeActionSpecifique === 'saisirMediateur') {
      if (!this.logged) {
        this.modalNonConnecte(codeOrgaContact);
        return false;
      } else if (!profilAllocataires) {
        this.displayPopupSaisirMediateurNonAutorisePasAllocataire(codeOrgaContact);
      } else {
        // ici on est forcément allocataire
        this.modalConnecte(codeOrgaContact);
      }
      return false;
    } else {
      return true;
    }
  }

  private redirectPageSelonProfil(profilConjointsNonRadies: boolean, profilTuteurAutresTutelles: boolean, profilTutelle4: boolean, profilEnfantsAutresPersonnes: boolean, profilUsagersPrimo: boolean) {
    if (profilConjointsNonRadies || profilTuteurAutresTutelles || profilTutelle4) {
      this.popupFonctionnaliteInaccessible('Envoyer un mail');
    } else {
      if (context.type === 'mobile') {
        this.goToPage('/redirect/s/Redirect?page=monCompteContactCafCourriel');
      } else if (profilEnfantsAutresPersonnes || profilUsagersPrimo) {
        this.router.navigate(['/contactcafprimocourriel']);
      } else {
        this.router.navigate(['/contactcafcourriel']);
      }
    }
  }

  private modalNonIdentifie() {
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-cnaf modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: 'Envoyer un mail',
        textBtnLeft: 'Je ne suis pas allocataire',
        textBtnRight: 'Je suis allocataire et je m\'identifie',
        content: ''
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      if (reason === 'btnLeft') {
        this.router.navigate(['/contactcafprimocourriel']);
      }
      else if (reason === 'btnRight') {
        this.goToPage('/redirect/s/Redirect?page=monCompteContactCafCourriel');
      }
      subscription.unsubscribe();
    });
  }

  private modalNonConnecte(codeOrgaContact: string) {
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-cnaf modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: 'Saisir le médiateur',
        textBtnLeft: 'Je ne suis pas allocataire',
        textBtnRight: 'Je suis allocataire et je m\'identifie',
        content: '<p>Pour accéder à cette fonctionnalité vous devez être allocataire.</p>'
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      if (reason === 'btnLeft') {
        this.displayPopupSaisirMediateurNonAutorisePasAllocataire(codeOrgaContact);
      } else if (reason === 'btnRight') {
        this.goToPage('/redirect/s/Redirect?page=monCompteContactCaf&typeActionSpecifique=saisirMediateur');
      }
      subscription.unsubscribe();
    });
  }

  private modalConnecte(codeOrgaContact: string) {
    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-cnaf modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: 'Saisir le médiateur',
        textBtnLeft: 'Faire une réclamation',
        textBtnRight: 'Continuer',
        content: `<p>Si vous n'avez fait aucune démarche, vous devez d'abord faire une réclamation.</p>
          <p>Si vous avez fait une réclamation et la réponse ne vous convient pas, vous pouvez continuer.</p>`
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      const clickInfo = this.tagXitiService.getAtClickObject(
        'name', // par défaut mais on change avant de faire le click
        'action',
        codeOrgaContact,
        LIBELLE_STAT.libelleContacterMaCaf,
        'popup_saisir_le_mediateur'
      );
      if (reason === 'btnLeft') {
        clickInfo.name = 'faire_une_reclamation'; // on change avant de faire le click
        this.cnafAtTagService.click(clickInfo);
        this.goToPage('/redirect/s/Redirect?page=monCompteContactCafCourriel');
      } else if (reason === 'btnRight') {
        clickInfo.name = 'continuer'; // on change avant de faire le click
        this.cnafAtTagService.click(clickInfo);
        if (context.type === 'mobile') {
          // pour l'instant même redirect
          // car demande métier de ne pas donner l'accès directement à la téléprocédure médiation dans l'application mobile
          this.goToPage('/redirect/s/Redirect?page=monCompteMediation');
        } else {
          this.goToPage('/redirect/s/Redirect?page=monCompteMediation');
        }
      }
      subscription.unsubscribe();
    });
  }

  private recuperationProfil() {
    const profilAllocataires = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES);
    const profilEnfantsAutresPersonnes = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ENFANTS_AUTRES_PERSONNES);
    const profilUsagersPrimo = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_USAGERS_PRIMO);
    const profilConjointsNonRadies = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_CONJOINTS)
      && !this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_RADIES);
    const profilTuteur = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_TUTEUR_PHYSIQUE)
      || this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_TUTEUR_MORAL);
    const profilTuteurAutresTutelles = (this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AUTRES_TUTELLES)
      && profilTuteur);
    const profilTutelle4 = (this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_TUTELLE4)
      && !profilTuteur);
    const profilAmi = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_AMI);
    const codeOrgaContact = this.getCodeOrgaContact(profilAmi, profilUsagersPrimo);
    return { profilConjointsNonRadies, profilTuteurAutresTutelles, profilTutelle4, profilEnfantsAutresPersonnes, profilUsagersPrimo, codeOrgaContact, profilAllocataires };
  }

  displayPopupSaisirMediateurNonAutorisePasAllocataire(codeOrgaContact: string): void {
    this.popupFonctionnaliteInaccessible('Saisir le médiateur');
    if (this.tagXitiService) {
      const tagObj = this.tagXitiService.getAtTagObject(
        'profil_non_aurorise_pas_allocataire',
        context.type,
        codeOrgaContact,
        LIBELLE_STAT.libelleContacterMaCaf,
        'saisir_le_mediateur'
      );
      this.cnafAtTagService.pageSend(tagObj);
    }
  }
  popupFonctionnaliteInaccessible(titrePopup: string): void {
    let content = '<p>Votre profil ne vous permet pas d\'accéder à cette fonctionnalité.</p>';
    if (titrePopup === 'Saisir le médiateur') {
      const profilUsagersPrimo = this.cnafUserService.isInGroup(this.cnafUserService.CNAF_LIST_GROUP.GROUP_USAGERS_PRIMO);
      if (!this.logged || profilUsagersPrimo) {
        content = '<p>Pour saisir le médiateur en ligne, vous devez être allocataire, être connecté à votre compte et avoir déjà effectué une démarche auprès de votre Caf afin de résoudre le problème.</p>';
      }
      else {
        content = '<p>Votre profil ne vous permet pas d\'accéder à cette fonctionnalité. Vous pouvez néanmoins saisir le médiateur de votre Caf par courrier.</p>';
      }
    }

    this.modalService.show(CnafPopupModalComponent, {
      class: 'modal-cnaf modal-contacter-caf-page-refonte',
      initialState: {
        version: 'v2',
        title: titrePopup,
        textBtnRight: 'Fermer',
        content
      },
      ariaLabelledBy: 'titlePopupModal'
    });
    const subscription = this.modalService.onHidden.subscribe((reason: string) => {
      subscription.unsubscribe();
    });
  }
  getWindowLocationSearch(): string {
    return window.location.search;
  }
  getWindowLocationHref(): string {
    return window.location.href;
  }
  removeUrlParams(sHref: string | undefined, sSearch: string | undefined, sParams: string[]): string | undefined {
    if (!sHref || !sSearch) {
      return sHref;
    }

    const sPageURL = sSearch.substring(1);
    const sURLVariables = sPageURL.split('&');
    const sSplitHref = sHref.split('?');
    let url = (`${sSplitHref[0]}?`);

    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParams.indexOf(sParameterName[0]) === -1) {
        url = (`${url}${sParameterName[0]}=${sParameterName[1]}&`);
      }
    }

    let sRoute = '';
    if (sSplitHref.length === 2 && sSplitHref[1]) {
      sRoute = sSplitHref[1].replace(sSearch.substring(1), '');
    }
    return url.substring(0, url.length - 1) + sRoute;
  }

  isBouton(element: any): any {
    return ('typeActionSpecifique' in element && element.typeActionSpecifique)
      || ('url' in element && element.url);
  }

  getUrlParams(): any {
    // @ts-ignore
    return window.getAllUrlParams(window.location.href);
  }

  getQuestions(codeOrga: string): Observable<Question[]> {
    const options = {
      params: new HttpParams()
    };
    return this.http.get<Question[]>(`${this.pagesFaqResource}/${codeOrga}`, options).pipe(catchError((error: HttpErrorResponse) => {
      // en cas d'erreur lors de l'appel du WS FAQ on renvoie en dure des FAQ
      const questions: Question[] = [
        {
          organisme: '',
          titre: 'Comment faire une réclamation ?',
          descriptifs: [
            {
              html: `
                  <p><strong>Quelle est votre situation ?</strong></p>
                  <ul>
                    <li>Vous ne comprenez pas une décision de la Caf.</li>
                    <li>Vous êtes mécontent du fonctionnement d'un service de votre Caf</li>
                    <li>Vous ne parvenez pas à obtenir une réponse claire à vos questions.</li>
                  </ul>
              `,
              titre: '',
              etat: '',
              url: '',
              typeActionSpecifique: ''
            },
            {
              html: `
                  <p><strong>Que devez-vous savoir ?</strong></p>
                  <p>Votre Caf met tout en œuvre pour traiter, dans les meilleurs délais, les demandes de ses allocataires.
                  Cependant, si vous n'êtes pas satisfait des décisions prises
                  (absence de réponse, désaccord avec la décision, etc.) ou de la qualité du service (qualité de l'accueil, du téléphone,
                  du site caf.fr, etc.) qui vous a été
                  rendu, vous pouvez déposer une réclamation auprès de votre Caf. Celle-ci s'engage à l'étudier et à vous répondre.</p>
              `,
              titre: '',
              etat: '',
              url: '',
              typeActionSpecifique: ''
            },
            {
              html: `
                <p><strong>Que devez-vous faire ?</strong></p>
                <p>Vous pouvez prendre contact avec votre Caf par mail :</p>
              `,
              titre: 'Faire une réclamation',
              etat: 'primaire',
              url: '',
              typeActionSpecifique: 'envoyerMail'
            },
            {
              html: `
                <p>Vous pouvez aussi déposer votre réclamation par courrier, par téléphone ou en vous déplaçant dans un point d'accueil Caf.</p>
              `,
              titre: 'Contacter votre Caf',
              etat: 'secondaire',
              url: '',
              typeActionSpecifique: 'scrollToContent'
            },
            {
              html: `
                <p>Si vous êtes allocataire et que votre réclamation n'a pas abouti, vous pouvez alors saisir le médiateur administratif de votre Caf.
                Il intervient lorsque vous avez fait toutes les démarches nécessaires auprès de votre Caf et qu'aucune solution n'a été trouvée.</p>
              `,
              titre: 'En savoir plus',
              etat: 'secondaire',
              url: '/redirect/s/Redirect?page=informationsMediation',
              typeActionSpecifique: '',
              ouvertureNouvelleFenetre: true
            },
            {
              html: ``,
              titre: 'Saisir le médiateur',
              etat: 'primaire',
              url: 'http://www.caf.fr/_typeActionSpecifique?nom=saisirMediateur',
              typeActionSpecifique: ''
            }
          ]
        },
        {
          organisme: '',
          titre: 'Comment contester une décision de la Caf ?',
          descriptifs: [
            {
              html: `
                <p><strong>Vous êtes en désaccord avec une décision administrative concernant votre dossier :</strong></p>
                <p>Vous pouvez saisir la Commission de recours amiable dans un délai de deux mois, à compter de la réception de la décision.</p>
              `,
              titre: '',
              etat: '',
              url: '',
              typeActionSpecifique: ''
            },
            {
              html: `
                <p>Un simple courrier suffit. Il n'est pas nécessaire de faire un envoi en recommandé.</p>
              `,
              titre: '',
              etat: '',
              url: '',
              typeActionSpecifique: ''
            },
            {
              html: `
                <p>Si votre demande de recours est rejetée, vous disposez de deux mois après réception de la Commission de recours amiable pour saisir le Tribunal
                judicaire de votre lieu de résidence.</p>
              `,
              titre: 'Accéder aux voies de recours',
              etat: 'primaire',
              url: '/redirect/s/Redirect?page=monCompteVoiesDeRecours',
              typeActionSpecifique: '',
              ouvertureNouvelleFenetre: false
            },
            {
              html: `
                <p>Les démarches à suivre sont indiquées sur le courrier de la Caf.</p>
              `,
              titre: '',
              etat: '',
              url: '',
              typeActionSpecifique: ''
            }
          ]
        }
      ];
      return of(questions);
    }));
  }

  isUndefOrNull(val: any): boolean {
    return val === undefined || val === null;
  }

  recupererInfos(): Promise<any>[] {
    const promises: Promise<any>[] = [];
    const options = {
      params: new HttpParams()
    };
    promises.push(this.http.get(`${this.contacterCafResource}infos_dossier`, options).toPromise());
    promises.push(this.http.get(`${this.pagesLocalesResource}`, options).toPromise());
    promises.push(this.http.get(`${this.contacterCafResource}autorisation_courriel`, options).toPromise());
    return promises;
  }

  getMotifs(params: any): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('pointEntree', params.pointEntree)
        .set('transactionId', params.transactionId)
    };
    return this.http.get(`${this.baseDeConnaissanceResource}motifs`,
      options
    );
  }

  postQuestion(postData: any): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.post(`${this.baseDeConnaissanceResource}question`, postData, options);
  }

  getRnProduct(code: string): string {
    let rnProduct = '';
    if (!(this.isUndefOrNull(code))) {
      LIBELLE_FORMULAIRE.listeObjetMessagePrimo.forEach(element => {
        if (element.code === code) {
          rnProduct = element.cleRnProduit;
        }
      });
    }
    return rnProduct;
  }

  postForm(postData: any): Observable<any> {
    const options = {
      params: new HttpParams()
    };
    return this.http.post(`${this.contacterCafResource}envoi_mail`, postData, options);
  }
  statsSidAccesRubrique(params: string, pSousrubrique: string): void {
    const statsSid = {} as CnafStatsSidModel;
    statsSid.composant = 'ContacterMaCafAppli';
    statsSid.rubrique = 'DIAWEB';
    statsSid.sousRubrique = pSousrubrique;
    statsSid.parametres = params;
    statsSid.portailVirtuel = 'caffr';
    this.cnafStatsSidService.postStats(statsSid, () => { /* rien à faire de particulier */ });
  }

  clean(str: string): string {
    if (str !== undefined && str !== null) {
      return str.toLowerCase()
        .replace(new RegExp(/[\u0300-\u036f]/g), '').replace(new RegExp(/[-&\/\\#,@!;+()$~%.'":*?<>{} ]/g), '_').replace(new RegExp(/[_]+/g), '_');
    }
    else {
      return '';
    }
  }
  getArticle(params: any): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('sessionId', params.sessionId)
        .set('transactionId', params.transactionId)
        .set('reponseId', params.reponseId)
        .set('pointEntree', params.pointEntree)
        .set('cleRnProduit', params.cleRnProduit)
        .set('modeFormuel', params.modeFormuel)
        .set('globalReponseId', params.globalReponseId)
    };
    return this.http.get(this.baseDeConnaissanceArticleResource,
      options
    );
  }

  // Appel sans gestion de retour
  // -> Inscription Statistique clickedArticle
  statLienArticle(params: any): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('sessionId', params.sessionId)
        .set('transactionId', params.transactionId)
        .set('reponseId', params.reponseId)
        .set('pointEntree', params.pointEntree)
        .set('cleRnProduit', params.cleRnProduit)
        .set('modeFormuel', params.modeFormuel)
    };
    return this.http.get(this.baseDeConnaissanceArticleResource,
      options
    );
  }

  getCookieByName(cookieName: string): string {
    return document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1');
  }

  public getLienCreationCompte(page: string): string {
    return `/redirect/s/Redirect?page=connectCreationCompte&contextePriseDeRDV=true&urlredirect=${page}`;
  }

  getAccessRdvTroov(codes: string, codeorga: string): Observable<boolean> {
    const options = {
      params: new HttpParams()
        .set('codes', codes)
        .set('codeorga', codeorga)
    };
    return this.http.get<{ result: boolean }>(this.accesPriseRdv, options).pipe(
      map(response => {
        if (Array.isArray(response) && response.length > 0) {
          const service = response[0].services.find((s: { code: string; result: boolean }) => s.code === "priseRdv");
          return service.result;
        }
      })
    );
  }

  public getDateEnvAAAMMJJ(): string {
    let dateString;
    if (this.cnafUserService.dateEnvCaffr !== undefined && this.cnafUserService.dateEnvCaffr.length >= 8) {
      dateString = this.cnafUserService.dateEnvCaffr;
    }else{
      const today = new Date();
      const year = today.getFullYear();
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDay()).slice(-2);
      dateString = `${year}${month}${day}`;
    }
    return dateString;
  }

  public getDateEnv(): Date {
    const dateString = this.getDateEnvAAAMMJJ();
    const year = Number(dateString.slice(0, 4));
    const month = Number(dateString.slice(4, 6)) - 1;
    const day = Number(dateString.slice(6));

    return new Date(year, month, day);
  }
}
